import useNodeTypeData from "./useNodeTypeData";

export default function useConnectAgentNode() {
  const { getNodeTypeData } = useNodeTypeData();

  const setConnectAgentNode = async params => {
    const { target, edgeId, setNodes, setEdgeLineParam, selectValueParam = "", nodeText } = params;

    let agentData = {};
    const nText = nodeText || "none";

    const isAgentNode = await getNodeTypeData(
      selectValueParam,
      typeof nText === "string" ? nText : JSON.stringify(nText),
      (msg, agentType) =>
        setNodes(prevNodes => {
          return prevNodes.map(l => {
            if (l.id === target) {
              // console.log(msg, agentType);
              agentData = { msg: msg.trim(), endFlag: false, agentType };
              return {
                ...l,
                data: {
                  ...l.data,
                  displayType: "Agent",
                  agentData,
                },
              };
            }
            return l;
          });
        })
    );

    if (isAgentNode) {
      setTimeout(() => {
        setNodes(prevNodes => {
          return prevNodes.map(l => {
            if (l.id === target) {
              return {
                ...l,
                data: {
                  ...l.data,
                  agentData: { ...agentData, endFlag: true },
                },
              };
            }
            return l;
          });
        });
      });

      setEdgeLineParam({
        id: edgeId,
        loading: false,
      });
      return true;
    }
  };

  return {
    setConnectAgentNode,
  };
}
